module.exports = __webpack_public_path__ + "static/media/rolling-bw.e131a606.jpg";